import { Text as Paragraph, Title } from '../../Typography';
import { Link } from '../../Link';
import type { FooterNavType } from '../types';
import type { ReactNode } from 'react';
import type { PathTranslations } from 'service/localization/getPathTranslations';
import { LinksService } from 'service/links/linksService';
import clsx from 'clsx';

const getMobileNavData = ({
  footerNav,
  onClickHandler,
  pathTranslations,
  socialMediaLinks,
  textColorToken,
}: {
  textColorToken?: string;
  pathTranslations: PathTranslations;
  socialMediaLinks?: ReactNode;
  onClickHandler: (target: string, linksTitle?: string) => void;
  footerNav?: FooterNavType[];
}) => {
  return footerNav
    ?.filter((navlist: FooterNavType) => navlist.footerNavType === 'MainNav')
    .map((navlistlink: FooterNavType) => {
      const bodyTempl = navlistlink?.links?.map((mobileLink: any) => (
        <Paragraph tag="p" type="md" key={mobileLink.id} className="block mb-2.5">
          <Link
            href={
              LinksService.getInternalLinks({ item: mobileLink, pathTranslations }) ||
              mobileLink?.url ||
              '/'
            }
            target={mobileLink?.openInNewTab ? '_blank' : '_self'}
            onClick={() =>
              onClickHandler(mobileLink?.displayName || '', navlistlink.cmsTitle || '')
            }
          >
            {mobileLink?.displayName}
          </Link>
        </Paragraph>
      ));
      return {
        title: (
          <Title
            tag="div"
            type="xs"
            className={clsx({
              'text-gray-500': !textColorToken,
            })}
            key={navlistlink.id}
          >
            {navlistlink.cmsTitle}
          </Title>
        ),
        body: (
          <div className="mb-5" key={navlistlink.id}>
            {navlistlink.socialMediaLink ? socialMediaLinks : bodyTempl}
          </div>
        ),
        id: navlistlink.cmsTitle,
      };
    });
};

export default getMobileNavData;
